import { Phone, Mail, ArrowRight } from "lucide-react";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { useLang } from "../i18n/LanguageContext";
import { CONTACT, waLink } from "../lib/site";

export default function Contact() {
  const { t } = useLang();
  const c = t.pages.contact;

  const cards = [
    { label: c.cs1, value: CONTACT.cs1, href: `https://wa.me/62${CONTACT.cs1.slice(1)}?text=${encodeURIComponent(c.waMsg)}`, icon: Phone, testId: "contact-cs1" },
    { label: c.cs2, value: CONTACT.cs2, href: `https://wa.me/62${CONTACT.cs2.slice(1)}?text=${encodeURIComponent(c.waMsg)}`, icon: Phone, testId: "contact-cs2" },
    { label: c.emailLabel, value: CONTACT.email, href: `mailto:${CONTACT.email}`, icon: Mail, testId: "contact-email" },
  ];

  return (
    <main data-testid="contact-page">
      <PageHero kicker={t.nav.contact} title={c.title} sub={c.sub} testId="contact-hero" />
      <section className="bg-white pb-20 md:pb-28">
        <div className="mx-auto max-w-5xl px-5 md:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {cards.map((card) => {
              const Icon = card.icon;
              return (
                <Reveal key={card.testId}>
                  <a
                    href={card.href}
                    target={card.icon === Phone ? "_blank" : undefined}
                    rel="noreferrer"
                    data-testid={card.testId}
                    className="group flex h-full flex-col rounded-2xl border border-black/5 bg-sinovar-soft p-7 hover:border-sinovar-blue/30 hover:shadow-xl transition-[box-shadow,border-color]"
                  >
                    <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-sinovar-blue/8 text-sinovar-blue group-hover:bg-sinovar-blue group-hover:text-white transition-colors">
                      <Icon className="h-6 w-6" strokeWidth={1.6} />
                    </div>
                    <div className="mt-6 text-xs font-semibold uppercase tracking-[0.1em] text-sinovar-navy/50">{card.label}</div>
                    <div className="mt-1 font-display text-lg font-semibold text-sinovar-navy break-all">{card.value}</div>
                    <span className="mt-auto pt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-sinovar-red">
                      {c.cta} <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
                    </span>
                  </a>
                </Reveal>
              );
            })}
          </div>

          <div className="mt-10 flex justify-center">
            <a
              href={waLink(c.waMsg)}
              target="_blank"
              rel="noreferrer"
              data-testid="contact-main-cta"
              className="group inline-flex items-center gap-2 rounded-full bg-sinovar-red px-8 py-4 text-sm font-semibold text-white hover:bg-[#c62828] transition-colors"
            >
              {t.nav.talk}
              <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
            </a>
          </div>
        </div>
      </section>
    </main>
  );
}
